import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'app/theme/layout'
import { Mail, Phone } from 'react-feather'

import Slider from 'app/theme/slider'
import BackgroundCover from 'app/theme/BackgroundCover'
import NavbarFixed from 'app/theme/NavbarFixed'
import useLeadModal from './useLeadModal'

import RecentActivations from './RecentActivations'

import bannerImg from './img/banners/axios-activation.png'

import styles from './AgencyPage.module.css'

import grid_halotop from './img/promotions-page/promotions_grid/agency-halotop.png'
import grid_notmilk from './img/promotions-page/promotions_grid/agency-notmilk.png'
import grid_alpha from './img/promotions-page/promotions_grid/agency-alpha.png'
import grid_seinfeld_nyc from './img/promotions-page/promotions_grid/agency-seinfeld-nyc.jpg'
import grid_bumble from './img/promotions-page/promotions_grid/agency-bumble.png'
import grid_portillos from './img/promotions-page/promotions_grid/agency-portillos.png'

import advantages_slideshow_1 from './img/promotions-page/advantages_slider/creamery.png'
import advantages_slideshow_2 from './img/promotions-page/advantages_slider/batiste.png'
import advantages_slideshow_3 from './img/promotions-page/advantages_slider/hearst.png'
import advantages_slideshow_4 from './img/promotions-page/advantages_slider/avocado.png'

import company_types_slideshow_1 from './img/promotions-page/company_types_slider/food_and_beverage.png'
import company_types_slideshow_2 from './img/promotions-page/company_types_slider/tech_and_software.png'
import company_types_slideshow_3 from './img/promotions-page/company_types_slider/CPG.png'
import company_types_slideshow_4 from './img/promotions-page/company_types_slider/sports_and_entertainment.png'
import company_types_slideshow_5 from './img/promotions-page/company_types_slider/travel_and_hospitality.png'

import advantages_grid_1 from './img/promotions-page/advantages_grid/alpha-foods.png'
import advantages_grid_2 from './img/promotions-page/advantages_grid/tums.png'
import advantages_grid_3 from './img/promotions-page/advantages_grid/waze.png'

import budweiser from './img/logos/budweiser.png'
import pepsi from './img/logos/pepsi.png'
import notco from './img/logos/notco.png'
import impossible from './img/logos/impossible.png'
import sony from './img/logos/sony.png'
import bumble from './img/logos/bumble.png'
import helloKitty from './img/logos/hello-kitty.png'
import vote from './img/logos/vote.png'
import barbie from './img/logos/barbie.png'
import ciroc from './img/logos/ciroc.png'
import shakeshack from './img/logos/shakeshack.png'
import walmart from './img/logos/walmart.png'

const menuItems = [
  {
    title: 'Key Advantages',
    url: `#key-advantages`,
  },
  {
    title: 'How it Works',
    url: `#how-it-works`,
  },
  {
    title: 'Industries',
    url: `#industries`,
  },
  {
    title: 'Case Studies',
    url: `#case-studies`,
  },
  {
    title: 'FAQ',
    url: `#faq`,
  },
]

const googleMetaTags = JSON.stringify(
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "What is a food truck promotion?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A food truck promotion is defined as an experiential marketing campaign activation that includes a food truck as a component. The food truck in these activations can be the focus or a part of a fully-immersive experience designed by our creative team. While adding a professional culinary experience to the food truck promotion can allow you to positively affect each of the senses of your potential customers, these activations do not have to include food."
      }
    },{
      "@type": "Question",
      "name": "How much does a food truck promotion cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The food truck promotions that we create at Roaming Hunger are each completely custom to our clients and their goals. This can lead costs to vary widely based on the items used or built, infrastructure, personnel, and location. While our team can work to assure that our clients are getting the most efficient use of their budgets, the minimum cost for a food truck promotion starts at around $25,000."
      }
    },{
      "@type": "Question",
      "name": "How do I create a food truck promotion?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": `<p>There are quite a few different components to creating a successful food truck promotion that will accomplish your goals and create an engaging, memorable experience for your audience. At a high level, your brand needs to focus on:</p>
                  <ol>
                    <li>
                      Having the right equipment, brand ambassadors, infrastructure, and permitting
                    </li>
                    <li>
                      Ensuring that you start with clear goals upon which to build your strategy
                    </li>
                    <li>
                      Scouting your locations to ensure they will work for your activation (and have permits)
                    </li>
                    <li>
                      A great on-the-ground team
                    </li>
                    <li>
                      Someone to manage and execute the food truck promotion
                    </li>
                    <li>
                      A sufficient budget to build and sustain your activation
                    </li>
                  </ol>`
        }
      }]
    }
)
export default function FoodTruckPromotionsPage(props) {

  const { Modal, openModal } = useLeadModal()

  return (
    <Layout>
      <Helmet>
        <title>Food Truck Promotions - Roaming Hunger</title>
        <meta name="description" content="Create mobile experiential marketing campaigns that will move your audience. Activate anywhere using our in-house location intelligence that we've built since 2009."></meta>
        <meta name="og:title" content={`Food Truck Promotions`}></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <BackgroundCover imageUrl={bannerImg}>
        <div className={styles.gradient}>
          <div className="container text-white py-20">
            <div className="xl:w-1/2 m-auto">
              <h1 className="font-platform leading-none text-5xl text-center leading-tight mb-6">
                Food Truck Promotions
              </h1>
              <p className="text-lg text-center font-light leading-tight mb-5 leading-relaxed">
                Create unique brand experiences that will move your audience. Anywhere.
              </p>
              <button
                className="btn btn-green font-platform text-2xl px-5 py-2 m-auto block"
                children="Get Started"
                onClick={openModal}
              />
            </div>
          </div>
        </div>
      </BackgroundCover>
      <NavbarFixed
        bgColor="bg-blue"
        className="text-white font-normal text-md"
        buttonStyle="text-white border-white border-2"
        onButtonClick={openModal}
        menuItems={menuItems}
      />
      <div id="clients" className="bg-white py-12">
        <div className="container text-center">
          <h2 className="font-platform text-3xl text-center text-navy w-full mb-6">
            A Few of Our Food Truck Promotions Customers
          </h2>
          <Slider
            arrows={false}
            dots={true}
            slidesToShow={4}
            slidesToScroll={4}
            responsive={[{
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            }]}
          >
            <div className="flex justify-center items-center">
              <img src={budweiser} alt="budweiser-logo" className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={pepsi} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={notco} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={impossible} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={sony} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={bumble} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={helloKitty} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={vote} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={barbie} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={ciroc} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={shakeshack} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={walmart} className={[styles.logo_images, "block m-auto"]} style={{height: '100px'}} />
            </div>
          </Slider>
        </div>
      </div>
      <div className="bg-white">
        <div className="container max-w-4xl pt-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">
            What Are Food Truck Promotions?
          </h2>
          <p className="mt-6">
            Whether your company is an established Fortune 500 firm or a startup trying to make a splash in the market,
            a food truck promotion helps to build positive brand awareness and connects you with potential customers.
            Food truck promotions can create experiences that people love to share, helping companies break into new
            markets where they want to make a lasting impact.
          </p>
          <p className="mt-6">
            A food truck promotion is defined as an <span className='font-bold text-navy'>experiential marketing campaign
            that includes a branded food truck as a component of the activation. </span>The food truck in these activations
            can be the focus or just a part of a fully-immersive experience designed by a creative team. While adding a
            professional culinary experience to the food truck promotion can allow you to positively affect each of the
            senses of your potential customers, these activations do not have to include food.
          </p>
        </div>
        <div className="container max-w-4xl py-12">
          <div className="grid grid-cols-3 gap-1 md:gap-3 lg:gap-6 text-white">
            <img src={grid_halotop} name="Halo Top" />
            <img src={grid_notmilk} name="NotMilk" />
            <img src={grid_alpha} name="Alpha" />
            <img src={grid_seinfeld_nyc} name="Seinfeld NYC" />
            <img src={grid_bumble} name="Bumble" />
            <img src={grid_portillos} name="Portillos" />
          </div>
        </div>
        <div className="container max-w-4xl pb-12 flex">
          <div className="flex-1 bg-navy p-12">
            <p className="text-center text-white italic pb-6">
              With over 12 years of experience creating food truck promotions, we can run the entire campaign. From our
              initial discovery meeting, we’ll set up your campaign for success from the first step.
            </p>
            <button
              className="btn btn-green font-platform text-xl px-5 py-2 m-auto block"
              children="Get Started"
              onClick={openModal}
            />
          </div>
        </div>
      </div>
      <div id="key-advantages" className="container max-w-4xl py-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">
          Advantages of Food Truck Promotions
        </h2>
        <p className="pb-6">
          The goal for a food truck promotion should be to create a once-in-a-lifetime experience for your brand.
          With 12 years of experience in this space, we’ve learned that successful food truck promotions craft
          an experience that people remember, talk about, and most importantly, share.
        </p>
        <p className="pb-6">
          Every promotion is a completely bespoke experience, so they come in all shapes and sizes. Each activation
          is built to achieve your desired objectives, so the right campaign for you depends on the goals of your brand.
        </p>
        <p className="pb-6">
          Food truck promotions can be used to increase sign-ups or downloads, create brand awareness, or as a PR campaign.
        </p>
        <p className="pb-6">
          A single successful activation can also be scaled into a larger mobile marketing tour, increasing your marketing
          impact while keeping costs down.
        </p>
      </div>

      <div className="container max-w-4xl">
        <Slider
          arrows={true}
          dots={false}
          slidesToShow={1}
          slidesToScroll={1}
          className={styles.slider_wrapper}
          responsive={[{
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]}
        >
          {[
            {
              image: advantages_slideshow_3,
              title: "Create micro-moments: ",
              description: "In our over 12 years of experience with food truck promotions, we have found that the best campaigns create positive micro-moments that attendees remember and associate with the brand for years to come. Food truck promotions provide an opportunity to do this in a way that other experiential marketing campaigns cannot."
            },
            {
              image: advantages_slideshow_2,
              title: "Engage the senses: ",
              description: "By adding a culinary experience to the activation, a brand has the opportunity to provide a positive experience for every single one of the senses of your audience. The smell of the food, the sound of the cooking, the anticipation as they wait, and of course the taste when it hits their watering mouths in that first moment, are all part of the experience. The branding, presentation, menu, and food truck itself will help position this positive memory into the consciousness of your target audience. "
            },
            {
              image: advantages_slideshow_1,
              title: "Travel anywhere: ",
              description: "Any landmark, big city street, or back country road can be a destination. As long as your target audience is there, you can connect with them. Mobility is one of the key advantage of food trucks, trailers and carts. What you’ll need is local expertise and (usually) permits to activate your food truck promotion."
            },
            {
              image: advantages_slideshow_4,
              title: "Go big (or small): ",
              description: "Food truck promotions can come in all shapes and sizes. Create large footprints at festivals and conventions that draw attention, or fit into small spaces with a food cart promotion, including indoors. The versatility of the vehicles opens up marketing opportunities that can fit any team or budget."
            },
          ].map(advantage => (
            <div key={advantage.title}>
              <img src={advantage.image} className={["m-auto"]}/>
              <p className="bg-white text-navy text-sm font-light px-5 lg:px-10 py-5">
                <span className="font-bold">{advantage.title} </span>{advantage.description}
              </p>
            </div>
          ))}
        </Slider>
      </div>

      <div className="container max-w-4xl my-6 bg-navy p-12">
        <p className="text-center text-white italic pb-6">
          We leverage our network of over 23,000 vendors to create food truck promotions anywhere in the US (and many
          global locations) and help brands make a lasting impression in their target markets and connect directly
          with the people that they want to reach.
        </p>
        <button
          className="btn btn-green font-platform text-xl px-5 py-2 m-auto block"
          children="Get Started"
          onClick={openModal}
        />
      </div>

      <div className="container max-w-4xl pt-12 px-0">
        <div className="grid grid-cols-3 gap-0 text-white">
          <img src={advantages_grid_1} name="Alpha Foods - SF" />
          <img src={advantages_grid_3} name="Waze" />
          <img src={advantages_grid_2} name="TUMS Smorgasberg" />
        </div>
      </div>

      <div id="how-it-works" className="container max-w-4xl pt-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">
          How a Food Truck Promotion Works
        </h2>
        <p className="mt-6">
          A food truck promotion provides many different levels of connection to your customers that other types
          of marketing campaigns cannot provide. It provides the opportunity to connect with your customers in
          the real world instead of online. It offers the chance to gain valuable insights into how the public
          perceives your brand but also gives you the ability to craft that experience and the impression they
          take away from it.
        </p>
        <p className="mt-6">
          Designing a food truck promotion with a holistic, ground-up approach, starts with your brand’s “why”
          and enables you to create a bespoke, once-in-a-lifetime event for your customers. Creative teams can
          use your desired outcomes to design an experience that will make your audience want to move in that
          direction. That could be sampling a new food item, capturing their social or contact information,
          informing them of a new product, or simply increasing positive brand awareness.
        </p>
        <p className="mt-6">
          If you choose to utilize a food truck promotion with a culinary aspect, that provides you with the
          unique opportunity to engage every one of your audiences’ senses in a way that no other marketing
          campaign or activation can.
        </p>
        <div className="my-12">
          <h3 className="pb-6 font-platform text-xl text-blue text-center">
            Here are a few tips to keep in mind when  creating a food truck promotion:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex">
              <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>1</label>
              <p className="flex-1 font-light">
                <span className="font-bold">Know who you want to connect with.</span> Bespoke activations are built with specific goals in mind,
                so your customer persona and target market are crucial, as they will drive the strategy.
              </p>
            </div>
            <div className="flex">
              <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>2</label>
              <p className="flex-1 font-light">
                <span className="font-bold">Next, you need to pick optimal activation locations.</span> The core tenets of marketing are connecting
                with the right person, at the right time, with the right message, and in the right location.
                This makes the city, venue, and even time of day extremely important.
              </p>
            </div>
            <div className="flex">
              <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>3</label>
              <p className="flex-1 font-light">
                <span className="font-bold">Whether it is built from scratch or rented, the correct footprint is key.</span> The environment for
                the activation needs to bring in and engage the audience, and be small or large enough to make
                a lasting impression.
              </p>
            </div>
            <div className="flex">
              <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>4</label>
              <p className="flex-1 font-light">
                <span className="font-bold">To get the best engagement out of your audience, you need to engage them.</span> Focus on as many senses
                as possible (touch, taste, smell, sound) to create a lasting memory.
              </p>
            </div>
            <div className="flex">
              <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>5</label>
              <p className="flex-1 font-light">
                <span className="font-bold">Make sure that you know what defines success from the start.</span> Having specific targets will help determine
                how to scale a program or repeat it in another market.
              </p>
            </div>
            <div className="flex">
              <label className="text-4xl text-navy font-bold font-platform" style={{minWidth: "30px"}}>6</label>
              <p className="flex-1 text-sm font-light">
                <span className="font-bold">Know your budget.</span> A food truck promotion might start at around $25k, but can easily go beyond a million
                dollars for complex activations.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container max-w-4xl my-12 bg-navy p-12">
        <p className="text-center text-white italic pb-6">
          Location expertise, planning, production, building a campaign to meet your goals, and encouraging high-impact
          interactions with your brand are critical components of success. These are the reasons that our clients continue
          to work with us.
        </p>
        <button
          className="btn btn-green font-platform text-xl px-5 py-2 m-auto block"
          children="Get Started"
          onClick={openModal}
        />
      </div>

      <div id="industries" className="bg-blue">
        <div className="container max-w-4xl my-12 bg-blue py-12 px-0">
          <h2 className="text-2xl text-white text-center font-platform mb-6">
            What Types of Companies Use Food Truck Promotions?
          </h2>

          <Slider
            arrows={true}
            dots={false}
            slidesToShow={1}
            slidesToScroll={1}
            className={styles.company_type_slider}
            responsive={[{
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }]}
          >
            {[
              {
                image: company_types_slideshow_1,
                title: "Food and Beverage",
                description: "Provide sampling, brand awareness or market testing across the nation to get instant feedback from your target market for a new product."
              },
              {
                image: company_types_slideshow_2,
                title: "Tech and Software",
                description: "Food truck promotions are an excellent way for tech companies to target existing B2B businesses, launch a new product, increase engagement, or make a splash at conferences or events."
              },
              {
                image: company_types_slideshow_3,
                title: "CPG",
                description: "Give away product samples to potential customers to build brand awareness and drive customers to retail or online for purchase."
              },
              {
                image: company_types_slideshow_4,
                title: "Sports and Entertainment",
                description: "Whether it’s creating buzz for an album, tv show, movie, or sports franchise, we have proven expertise in getting brands’ messages to their target markets."
              },
              {
                image: company_types_slideshow_5,
                title: "Travel and Hospitality",
                description: "Food truck promotions can give potential travelers a taste of your country or destination by creating an immersive cultural experience."
              },
            ].map(company_type => (
              <div key={company_type.title} className="relative">
                <img src={company_type.image} className={["m-auto"]}/>
                <p
                  className={[
                    "bg-white lg:absolute text-navy text-sm font-light p-4",
                    styles.company_type_caption
                  ]}
                >
                  <span className="font-bold text-lg font-platform text-green block text-center">
                    {company_type.title}
                  </span>
                  {company_type.description}
                </p>
              </div>
            ))}
          </Slider>

          <button
            className="text-white border-white border-2 font-platform text-lg px-5 py-2 m-auto mt-5 block"
            children="Get Started"
            onClick={openModal}
          />
        </div>
      </div>

      <div id="case-studies" className="container max-w-4xl my-12 p-12">
        <RecentActivations
          case_study_tags={['food_truck_promotion']}
        />
      </div>

      <div id="faq" className="bg-navy py-12 text-white">
        <div className="container max-w-4xl m-auto">
          <h2 className="text-3xl text-center font-platform mb-6">
            Frequently Asked Questions
          </h2>
          <h3 className="text-xl font-platform mb-4">
            What is a food truck promotion?
          </h3>
          <p className="font-light mb-4">
            A food truck promotion is an experiential marketing campaign that includes a food truck as part of the activation.
            The food truck in these activations can be the centerpiece, or simply a part of a larger experience. While adding
            a culinary component to a food truck promotion can enhance the experience, these activations do not have to include
            food.
          </p>
          <h3 className="text-xl font-platform mb-4">
            How much does a food truck promotion cost?
          </h3>
          <p className="font-light mb-4">
            The food truck promotions that we create at Roaming Hunger are each completely custom for our clients and their goals.
            This can lead costs to vary widely based on the items used or built, infrastructure, personnel, and location.
            While our team can work to assure that our clients are getting the most efficient use of their budgets,
            the minimum cost for a food truck promotion starts at around $25,000.
          </p>
          <h3 className="text-xl font-platform mb-4">
            How do I create a food truck promotion?
          </h3>
          <p className="font-light mb-4">
            There are quite a few different components to creating a successful food truck promotion that will accomplish
            your goals and create an engaging, memorable experience for your audience. At a high level, your brand needs to
            focus on:
          </p>
          <ol className="list-disc pl-4 font-light">
            <li className="">Having the right equipment, brand ambassadors, infrastructure, and permitting</li>
            <li>Ensuring that you start with clear goals upon which to build your strategy</li>
            <li>Scouting your locations to ensure they will work for your activation (and have permits)</li>
            <li>A great on-the-ground team</li>
            <li>Someone to manage and execute the food truck promotion</li>
            <li>A sufficient budget to build and sustain your activation.</li>
          </ol>
        </div>
      </div>

      <div className="bg-blue text-white text-center py-12 px-6">
        <h3 className="text-3xl font-platform mb-4">Ready to Launch a Food Truck Promotion?</h3>
        <p className="text-md pb-5"><Phone className="inline" size={16} /> (424) 777-2550</p>
        <p className="text-md pb-5"><Mail className="inline" size={16} /> rmng@roaminghunger.com</p>
        <button
          className="btn btn-navy font-platform text-md mt-2 px-5 py-2"
          children="Contact Us"
          onClick={openModal}
        />
      </div>
      <Modal />
    </Layout>
  )
}